import React from 'react';
import { Box, Typography } from '@mui/material';
import { AppColors } from '../theme/colors';

/**
 * 利用規約・プライバシーポリシーへの同意の案内
 *
 * ログイン画面と管理者ログイン画面の両方に置く。
 * 同じ文言を各画面に書くと、片方だけ直されて食い違うため部品にしている。
 *
 * QR / 専用URL からのログインは読み取った時点でログインが完了し、この案内を
 * 表示する画面が無い。配布物や利用中の画面での案内をどうするかは別途検討する。
 */
export const TermsNotice: React.FC = () => {
  const linkSx = {
    color: AppColors.primary,
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: AppColors.primaryDark,
      textDecoration: 'underline',
    },
  };

  return (
    <Typography
      variant="body2"
      align="center"
      sx={{
        fontSize: '0.75rem',
        color: AppColors.textTertiary,
        mt: 2,
      }}
    >
      ログインすることで、
      <Box
        component="span"
        sx={linkSx}
        onClick={() => (window.location.href = '/terms-of-service')}
      >
        利用規約
      </Box>
      と
      <Box
        component="span"
        sx={linkSx}
        onClick={() => (window.location.href = '/privacy-policy')}
      >
        プライバシーポリシー
      </Box>
      に同意したものとみなされます
    </Typography>
  );
};

export default TermsNotice;
